"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _types = require("./types");
var _ = _interopRequireDefault(require(".."));
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var computeValue = function computeValue(value) {
  if (typeof value === "number") {
    return "".concat(value || 0, "px");
  }
  return value;
};
var ContainerDiv = (0, _styledComponents["default"])(_["default"]).withConfig({
  displayName: "PositionBox__ContainerDiv",
  componentId: "sc-1n0twys-0"
})(["position:", ";top:", ";left:", ";bottom:", ";right:", ";z-index:", ";"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) || _types.PositionBoxTypes.RELATIVE;
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.top);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.left);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.bottom);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.right);
}, function (props) {
  return props.zIndex || 1;
});
var PositionBox = function PositionBox(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ContainerDiv, _extends({
    "data-test-class": "sui-position"
  }, props, {
    "data-sentry-element": "ContainerDiv",
    "data-sentry-component": "PositionBox",
    "data-sentry-source-file": "index.tsx"
  }), children);
};
PositionBox[_types.PositionBoxTypes.RELATIVE] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.RELATIVE
  }, props));
};
PositionBox[_types.PositionBoxTypes.ABSOLUTE] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.ABSOLUTE
  }, props));
};
PositionBox[_types.PositionBoxTypes.FIXED] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.FIXED
  }, props));
};
PositionBox[_types.PositionBoxTypes.STICKY] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.STICKY
  }, props));
};
var _default = exports["default"] = PositionBox;